import React, { useEffect } from 'react'
import HeaderPage from '../HeaderPage/HeaderPage'
import Workflow from '../Workflow/Workflow'
import WorkSpace from '../Workspace/WorkSpace'
import Products from '../Products/Products'
import OurService from '../OurService/OurService'
import NewsLetter from '../NewsLetter/NewsLetter'

const Home = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <div>
      <HeaderPage />
      <WorkSpace />
      <OurService />
      {/* <Workflow /> */}
      <NewsLetter />
      {/* <Products/> */}
    </div>
  )
}

export default Home